<template>
  <v-card height="100%" class="rounded-input elevation-black">
    <v-card-text class="pa-0 fill-height">
      <v-img
        v-if="fotoSeleccionada"
        :src="fotoSeleccionada"
        class="rounded-input"
        height="100%"
        width="100%"
      >
        <v-row no-gutters justify="end" class="px-4 pt-4">
          <v-col cols="auto">
            <v-btn
              x-small
              width="45px"
              height="45px"
              depressed
              class="gradient-error rounded-input"
              @click="fotoSeleccionada = null"
            >
              <v-icon color="white"> mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-img>
      <template v-else>
        <v-row no-gutters justify="end" class="px-4 pt-4">
          <v-col cols="auto">
            <v-btn
              x-small
              width="45px"
              height="45px"
              depressed
              class="gradient-error rounded-input"
              @click="onClickCerrar"
            >
              <v-icon color="white"> mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters class="px-2" v-if="fotos.length > 0">
          <v-col
            cols="3"
            v-for="(foto, index) in fotos"
            :key="`foto-${index}`"
            class="pa-2"
          >
            <v-card flat class="rounded-input" @click="seleccionarFoto(foto)">
              <v-img :src="foto" class="rounded-input"></v-img>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else no-gutters class="pt-3 px-2" justify="center">
          <v-col cols="auto" class="text--text metropolis text-body-1">
            {{ $t("reportes.galeria.no-data-message") }}
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
//decoradores
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
//tipos
import { Pesaje } from "@/typings/store/plugins/easyFirestore/pesajes";
import {
  Archivo,
  Archivos,
} from "@/typings/store/plugins/easyFirestore/archivos";

@Component
export default class GaleriaImagenes extends Vue {
  @Prop() readonly pesaje!: Pesaje;
  @Prop() readonly archivos!: Archivos;

  fotoSeleccionada: string | null = null;

  get arrayArchivos(): Array<Archivo> {
    return Object.values(this.archivos);
  }

  get fotos(): Array<string> {
    return this.pesaje.fotos.map((foto) => {
      return foto.url ?? "";
    });
  }

  @Watch("pesaje")
  onPesajeChange(): void {
    this.fotoSeleccionada = null;
  }

  @Emit("click:cerrar")
  onClickCerrar(): void {
    return;
  }

  seleccionarFoto(foto: string): void {
    this.fotoSeleccionada = foto;
  }
}
</script>

<style scoped></style>
